"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTableElement = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_1 = require("@ant-design/icons");
var antd_1 = require("antd");
var react_1 = require("react");
var icons_2 = require("@ant-design/icons");
var helpers_1 = require("../utils/helpers");
var ACButton_1 = require("./ACButton");
var ACSwitchElement_1 = require("./ACSwitchElement");
var useScreenDimensions_1 = __importDefault(require("../hooks/useScreenDimensions"));
var ACTableElement = function (props) {
    var _a, _b;
    var thead = props.thead, tbody = props.tbody, context = props.context;
    var _c = (0, react_1.useState)(355), tableHeight = _c[0], setTableHeight = _c[1];
    var _d = (0, react_1.useState)([]), dataSource = _d[0], setDataSource = _d[1];
    var _e = (0, react_1.useState)([]), mutatedData = _e[0], setMutatedData = _e[1];
    var _f = (0, react_1.useState)({
        page: ((_a = props.value) === null || _a === void 0 ? void 0 : _a.page) || 1,
        pageSize: ((_b = props.value) === null || _b === void 0 ? void 0 : _b.pageSize) || 30,
    }), pagination = _f[0], setPagination = _f[1];
    var _g = (0, react_1.useState)({}), newFilters = _g[0], setNewFilters = _g[1];
    var _h = (0, react_1.useState)([]), expandedRowKeys = _h[0], setExpandedRowKeys = _h[1];
    var dimensions = (0, useScreenDimensions_1.default)();
    var getFiltersFromRedux = function (colProps) {
        var _a, _b;
        var state = (_b = (_a = context === null || context === void 0 ? void 0 : context.state) === null || _a === void 0 ? void 0 : _a.dynamic) === null || _b === void 0 ? void 0 : _b[(context === null || context === void 0 ? void 0 : context.rootState) || ''];
        var _c = colProps || {}, filtersSource = _c.filtersSource, _d = _c.filters, filters = _d === void 0 ? [] : _d;
        return (helpers_1.Helper.getNestedValue(state, filtersSource === null || filtersSource === void 0 ? void 0 : filtersSource.storedLocation) ||
            filters ||
            []);
    };
    (0, react_1.useEffect)(function () {
        var _a;
        if (props.value && props.value.name === 'pagination') {
            setPagination({
                page: props.value.page || 1,
                pageSize: ((_a = props.value) === null || _a === void 0 ? void 0 : _a.pageSize) || 30,
            });
        }
    }, [props.value]);
    (0, react_1.useEffect)(function () {
        if (tbody) {
            var rows = tbody;
            if (typeof tbody === 'object' &&
                'data' in tbody &&
                Array.isArray(tbody.data)) {
                // console.log('__went in here', rows);
                rows = tbody.data;
                // console.log('__rows', rows);
            }
            if (Array.isArray(rows)) {
                setDataSource(rows === null || rows === void 0 ? void 0 : rows.map(function (row, index) {
                    var _a;
                    var pagnationIdx = ((pagination.page || 1) - 1) * (pagination.pageSize || 30);
                    return __assign(__assign({}, row), { key: row.id || pagnationIdx + index + 1, index: pagnationIdx + index + 1, children: row.children && ((_a = row.children) === null || _a === void 0 ? void 0 : _a.length) > 0
                            ? row.children
                            : undefined });
                }));
            }
        }
    }, [tbody, pagination]);
    (0, react_1.useEffect)(function () {
        if (tbody && thead) {
            var newMutatedData = JSON.parse(JSON.stringify(dataSource));
            // Helper function to get value from nested path
            // Process each record in the copied array
            newMutatedData.forEach(function (record) {
                var originalRecord = JSON.parse(JSON.stringify(record));
                // console.log('originalRecord', originalRecord);
                // First, ensure all expected fields exist in the record
                thead.forEach(function (col) {
                    // Initialize the column name with null if it doesn't exist
                    // Process dataKey if different from name
                    if (col.dataKey && col.dataKey !== col.name) {
                        var value = helpers_1.Helper.getNestedValue(record, col.dataKey);
                        // Always assign the value, even if undefined (which will become null)
                        record[col.name] = value !== undefined ? value : null;
                    }
                    if (!(record === null || record === void 0 ? void 0 : record[col === null || col === void 0 ? void 0 : col.name])) {
                        record[col.name] = (col === null || col === void 0 ? void 0 : col.displayHyphenIfEmpty) === false ? '' : '--';
                    }
                });
                // Now process renderers with all fields guaranteed to exist
                thead.forEach(function (col) {
                    var _a;
                    if (col.renderers) {
                        // Create a deep copy of the renderers for this record
                        var renderersCopy = JSON.parse(JSON.stringify(col.renderers));
                        var newRenderers_1 = [];
                        renderersCopy.forEach(function (renderer) {
                            if (renderer.element) {
                                if ('valueKey' in renderer) {
                                    renderer[renderer.valueKey] = record[col.name];
                                }
                                else {
                                    if (renderer.label === undefined) {
                                        renderer.label = record[col.name];
                                    }
                                }
                            }
                            else if (renderer.fields && Array.isArray(renderer.fields)) {
                                renderer.fields.forEach(function (field) {
                                    if ('title' in field && typeof field.title === 'object') {
                                        // First process the message with string interpolation
                                        var processedMessage = field.title.message.replace(/\${([^}]+)}/g, function (match, key) {
                                            var value = originalRecord[key];
                                            // Ensure the value is a string or number to prevent React errors
                                            if (value === null || value === undefined) {
                                                return match;
                                            }
                                            else if (typeof value === 'object') {
                                                return JSON.stringify(value); // Convert objects to strings
                                            }
                                            else {
                                                return String(value); // Ensure non-objects are converted to strings
                                            }
                                        });
                                        // Replace the entire title object with the processed string
                                        field.title = processedMessage;
                                    }
                                    if (field.element && field.label === undefined) {
                                        field.label = record[col.name];
                                    }
                                });
                            }
                            if (props === null || props === void 0 ? void 0 : props.rowIDKeyName) {
                                var name_1 = (renderer === null || renderer === void 0 ? void 0 : renderer.name) || (col === null || col === void 0 ? void 0 : col.name);
                                var value = originalRecord === null || originalRecord === void 0 ? void 0 : originalRecord[props.rowIDKeyName];
                                renderer[props.rowIDKeyName] = value;
                                renderer['name'] = "".concat(name_1 ? "".concat(name_1, "_") : '').concat(value);
                            }
                            newRenderers_1.push(renderer);
                        });
                        var res = [
                            {
                                name: col === null || col === void 0 ? void 0 : col.name,
                                className: col === null || col === void 0 ? void 0 : col.className,
                                fields: newRenderers_1,
                            },
                        ];
                        record[col.name] = (_a = props.renderFields) === null || _a === void 0 ? void 0 : _a.call(props, res, originalRecord, col.name);
                    }
                });
                // Process action renderers
                var actionsBlock = thead.find(function (col) { return col.name === 'actions'; });
                if (actionsBlock && 'renderers' in actionsBlock) {
                    // Create a deep copy of action renderers for this record
                    var renderersCopy = JSON.parse(JSON.stringify(actionsBlock.renderers));
                    renderersCopy.forEach(function (renderer) {
                        var _a;
                        record['actions'] = (_a = props.renderFields) === null || _a === void 0 ? void 0 : _a.call(props, [renderer], originalRecord);
                    });
                }
            });
            // Update state with the fully processed data
            setMutatedData(newMutatedData);
        }
    }, [tbody, thead, dataSource]);
    (0, react_1.useEffect)(function () {
        // Automatically expand the first record with children
        var firstRecordWithChildren = dataSource.find(function (record) { var _a; return record.children && ((_a = record.children) === null || _a === void 0 ? void 0 : _a.length) > 0; });
        if ((firstRecordWithChildren === null || firstRecordWithChildren === void 0 ? void 0 : firstRecordWithChildren.key) !== undefined) {
            setExpandedRowKeys([firstRecordWithChildren.key]); // Use the key of the record, not a hardcoded value
        }
    }, [dataSource]);
    var memoizedDimensions = (0, react_1.useMemo)(function () { return dimensions; }, [dimensions]);
    (0, react_1.useEffect)(function () {
        setTableHeight(memoizedDimensions.height - ((props === null || props === void 0 ? void 0 : props.tableHeight) || 355));
    }, [memoizedDimensions]);
    var handleDelete = function (record) {
        props.onChange && props.onChange({ name: record.key, value: record });
    };
    var handleSwitch = function (record) {
        var newDataSource = dataSource.map(function (item) {
            if (item.id === record.id) {
                var updatedRecord = __assign(__assign({}, item), { value: !item.value });
                props.onChange &&
                    props.onChange({ name: record.key, value: updatedRecord });
                return updatedRecord;
            }
            return item;
        });
        setDataSource(newDataSource);
    };
    var handleTableChange = function (_pagination, newFilters, _sorter, extra) {
        var _a, _b;
        void _sorter;
        if (extra.action === 'paginate') {
            setPagination({
                page: (_a = _pagination.current) !== null && _a !== void 0 ? _a : 1,
                pageSize: (_b = _pagination.pageSize) !== null && _b !== void 0 ? _b : 30,
            });
            if (props.onChange) {
                props.onChange({
                    name: 'pagination',
                    page: _pagination.current,
                    pageSize: _pagination.pageSize,
                });
            }
        }
        else if (extra.action === 'filter') {
            setNewFilters(newFilters);
            if (props.onChange) {
                // setPagination({
                //   page: 1,
                //   pageSize: _pagination.pageSize ?? 30,
                // });
                props.onChange({ name: 'filters', value: newFilters });
                props.onChange({
                    name: 'pagination',
                    page: 1,
                    pageSize: _pagination.pageSize,
                });
            }
        }
    };
    var columns = [];
    if (thead) {
        columns = __spreadArray(__spreadArray([], (props.showSerialNumber || props.showSerialNumber === undefined
            ? [
                {
                    title: '#',
                    dataIndex: 'index',
                    key: 'index',
                    width: props.indexWidth || 40,
                    fixed: 'left',
                    clickable: props.indexClickable,
                },
            ]
            : []), true), thead.map(function (col, index) {
            var filtersList = getFiltersFromRedux(col) || [];
            return {
                title: col.label,
                dataIndex: col.name,
                key: col.key,
                fixed: col.fixed,
                ellipsis: col.ellipsis,
                width: col.width || 100,
                clickable: col.clickable,
                render: index === 0 && props.rowClickExpandable
                    ? function (text, record) {
                        var _a;
                        return ((0, jsx_runtime_1.jsx)("span", { onClick: function (e) {
                                var _a;
                                if (record.children && ((_a = record.children) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                                    e.stopPropagation();
                                    setExpandedRowKeys(function (prev) {
                                        return prev.includes(record.key)
                                            ? prev.filter(function (key) { return key !== record.key; })
                                            : __spreadArray(__spreadArray([], prev, true), [record.key], false);
                                    });
                                }
                            }, style: ((_a = record.children) === null || _a === void 0 ? void 0 : _a.length)
                                ? {
                                    cursor: 'pointer',
                                    fontWeight: '600',
                                    marginLeft: '8px',
                                    textTransform: 'capitalize',
                                }
                                : { cursor: 'default' }, children: text }));
                    }
                    : col.render,
                filters: (filtersList === null || filtersList === void 0 ? void 0 : filtersList.length) > 0 &&
                    (filtersList === null || filtersList === void 0 ? void 0 : filtersList.map(function (filter) { return ({
                        text: (filter === null || filter === void 0 ? void 0 : filter.text) || (filter === null || filter === void 0 ? void 0 : filter.label),
                        value: filter.value,
                    }); })),
                filterIcon: function () {
                    var _a;
                    var currentFilters = ((_a = newFilters === null || newFilters === void 0 ? void 0 : newFilters[col.name]) === null || _a === void 0 ? void 0 : _a.length) || 0;
                    return currentFilters > 0 ? ((0, jsx_runtime_1.jsx)(antd_1.Badge, { count: currentFilters, size: "small", children: (0, jsx_runtime_1.jsx)(icons_1.FilterFilled, {}) })) : ((0, jsx_runtime_1.jsx)(icons_1.FilterFilled, {}));
                },
                filterMultiple: true,
                // sorter:
                //   col.sortable ||
                //   (col.sortable === undefined && {
                //     compare: (
                //       a: { [x: string]: string | number },
                //       b: { [x: string]: string | number },
                //     ) => {
                //       const aValue = a[col.key!];
                //       const bValue = b[col.key!];
                //       if (typeof aValue === 'number' && typeof bValue === 'number') {
                //         return aValue - bValue;
                //       } else if (
                //         typeof aValue === 'string' &&
                //         typeof bValue === 'string'
                //       ) {
                //         return aValue.localeCompare(bValue);
                //       } else {
                //         return 0;
                //       }
                //     },
                //   }),
            };
        }), true);
        if (props.isDelete) {
            columns === null || columns === void 0 ? void 0 : columns.push({
                title: 'Delete',
                dataIndex: 'Delete',
                key: 'Delete',
                render: function (_, record) {
                    return ((0, jsx_runtime_1.jsx)(antd_1.Popconfirm, { title: "Delete the task", description: "Are you sure to delete this task?", icon: (0, jsx_runtime_1.jsx)(icons_2.QuestionCircleOutlined, { style: { color: 'red' } }), onConfirm: function () { return handleDelete(record); }, okText: "Delete", cancelText: "Cancel", children: (0, jsx_runtime_1.jsxs)(antd_1.Tooltip, { title: "Delete", children: [(0, jsx_runtime_1.jsx)("p", { children: "Del" }), (0, jsx_runtime_1.jsx)(ACButton_1.ACButton, { name: "delete", icon: "discard" })] }) }));
                },
            });
        }
        if (props === null || props === void 0 ? void 0 : props.isStatus) {
            columns === null || columns === void 0 ? void 0 : columns.splice(-1, 0, {
                title: 'Status',
                dataIndex: 'Status',
                key: 'Status',
                render: function (_, record) {
                    return ((0, jsx_runtime_1.jsx)(ACSwitchElement_1.ACSwitchElement, { value: record.value, onChange: function () {
                            handleSwitch(record);
                        } }));
                },
            });
        }
    }
    var rowSelectionConfig = props.rowSelection
        ? {
            onChange: function (selectedRows) {
                if (props.onChange) {
                    props.onChange(selectedRows);
                }
            },
        }
        : undefined;
    var handleRowClick = function (record) {
        if (props.onChange) {
            props.onChange({ name: 'view', value: __assign({}, record) });
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: props.expandIcon ? '' : 'tree-table', style: { position: 'relative' }, children: (0, jsx_runtime_1.jsx)(antd_1.Table
        // virtual
        , { 
            // virtual
            style: {
                userSelect: (props === null || props === void 0 ? void 0 : props.rowClick) !== true ? 'auto' : 'none',
                overflowY: 'auto',
            }, loading: props.loading, className: "apx-ui_table ".concat((props === null || props === void 0 ? void 0 : props.rowClick) ? 'row-clickable' : '', " ").concat(props.className), scroll: {
                x: 'max-content',
                y: props.fullHeight ? '' : tableHeight,
            }, pagination: props.pagination
                ? {
                    align: 'end',
                    current: pagination.page,
                    pageSize: pagination.pageSize,
                    pageSizeOptions: [10, 20, 30, 50, 100],
                    showTotal: function (total) { return "Total: ".concat(total, " items"); },
                    total: props.count,
                    showSizeChanger: props.count ? props.count > 10 : 0 > 10,
                    style: {
                        position: 'sticky',
                        bottom: '0',
                        left: '0',
                        backgroundColor: '#ffffff',
                        // boxShadow: '0 -1px 4px rgba(0, 0, 0, 0.1)',
                        textAlign: 'center',
                        padding: '5px 0',
                        zIndex: 10,
                    },
                }
                : false, rowSelection: rowSelectionConfig, dataSource: mutatedData, columns: columns.map(function (col) { return (__assign(__assign({}, col), { onCell: function (_record) { return ({
                    style: {
                        cursor: col.clickable === false || (props === null || props === void 0 ? void 0 : props.rowClick) !== true
                            ? 'auto'
                            : 'pointer',
                    },
                }); } })); }), size: props.size, bordered: true, expandable: {
                expandedRowKeys: expandedRowKeys,
                onExpand: function (expanded, record) {
                    setExpandedRowKeys(function (prevExpandedRowKeys) {
                        if (expanded) {
                            return __spreadArray(__spreadArray([], prevExpandedRowKeys, true), [record.key], false);
                        }
                        else {
                            return prevExpandedRowKeys.filter(function (key) { return key !== record.key; });
                        }
                    });
                },
                rowExpandable: function (record) {
                    return !!(record.children && record.children.length > 0);
                },
                expandIcon: props.expandIcon
                    ? function (_a) {
                        var _b;
                        var expanded = _a.expanded, onExpand = _a.onExpand, record = _a.record;
                        return record.children && ((_b = record.children) === null || _b === void 0 ? void 0 : _b.length) > 0 ? (expanded ? ((0, jsx_runtime_1.jsx)(icons_2.DownOutlined, { onClick: function (e) { return onExpand(record, e); }, style: {
                                float: props.expandIconStyles ? 'left' : undefined,
                                paddingTop: '5px',
                            } })) : ((0, jsx_runtime_1.jsx)(icons_2.RightOutlined, { onClick: function (e) { return onExpand(record, e); }, style: {
                                float: props.expandIconStyles ? 'left' : undefined,
                                paddingTop: '5px',
                            } }))) : null;
                    }
                    : undefined,
            }, onChange: handleTableChange, onRow: function (record) {
                return {
                    onClick: function (event) {
                        var clickedCell = event.target.closest('td');
                        if (!clickedCell || !clickedCell.parentNode)
                            return;
                        var columnIndex = Array.from(clickedCell.parentNode.children).indexOf(clickedCell);
                        var columnConfig = columns === null || columns === void 0 ? void 0 : columns[columnIndex];
                        if (columnConfig && columnConfig.clickable === false) {
                            return;
                        }
                        if (props.rowClick === true || props.rowClick === undefined) {
                            handleRowClick(record);
                        }
                        if (props.expandable && record.key !== undefined) {
                            var isRowExpanded_1 = expandedRowKeys.includes(record.key);
                            setExpandedRowKeys(function (prev) {
                                return isRowExpanded_1
                                    ? prev.filter(function (key) { return key !== record.key; })
                                    : __spreadArray(__spreadArray([], prev, true), [record.key], false);
                            });
                        }
                    },
                };
            }, rowClassName: function () {
                return props.rowClick === true ||
                    props.rowClick === undefined ||
                    props.expandable
                    ? 'cursor-pointer'
                    : '';
            } }) }));
};
exports.ACTableElement = ACTableElement;
